import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';

import CollectionsListFilter from '../../components/CollectionsListFilter/CollectionsListFilter';
import CollectionsListItem from '../../components/CollectionsListItem/CollectionsListItem';
import CollectionsBillboard from '../../components/CollectionsBillboard/CollectionsBillboard';
import DyPage from '../../templates/DyPage';
import { StyledUl } from './CollectionsListStyles';

var CollectionsList = function CollectionsList(props) {
  // collection_list_items and filter data come from src/snippets/collection-list.liquid
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      activeFilter = _useState2[0],
      setActiveFilter = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      filteredItems = _useState4[0],
      setFilteredItems = _useState4[1];

  var handleFilterChange = function handleFilterChange(e) {
    var newActiveFilter = '';
    if (e.target.value !== activeFilter) {
      newActiveFilter = e.target.value;
    }
    setActiveFilter(newActiveFilter);
  };

  useEffect(function () {
    // on active filter change, filter items
    var filterItems = function filterItems() {
      var filteredItems = [].concat(_toConsumableArray(props.data.collection_list_items));
      if (activeFilter !== '') {
        filteredItems = filteredItems.filter(function (i) {
          if (i.primary_color === activeFilter || i.accent_color === activeFilter) {
            return i;
          }
        });
      }
      setFilteredItems(filteredItems);
    };
    filterItems();
  }, [activeFilter, props.data.collection_list_items]);

  var itemsToDisplay = filteredItems.length ? filteredItems : props.data.collection_list_items;

  var showBillboard = activeFilter === '' || props.collectionsBillboard.primary_color === activeFilter || props.collectionsBillboard.accent_color === activeFilter;

  var isCollectionsList = window.location.pathname === '/collections';

  return React.createElement(
    Fragment,
    null,
    React.createElement(CollectionsListFilter, {
      filters: props.data.collection_filter_colors,
      activeFilter: activeFilter,
      handleFilterChange: handleFilterChange
    }),
    React.createElement(
      StyledUl,
      null,
      itemsToDisplay.map(function (item) {
        return React.createElement(CollectionsListItem, {
          key: item.handle,
          url: item.url.includes('/products/') ? 'products/' + item.handle : 'collections/' + item.handle,
          image: item.image,
          title: item.title
        });
      }),
      showBillboard && isCollectionsList && React.createElement(CollectionsBillboard, {
        itemsToDisplay: itemsToDisplay,
        collectionsBillboard: props.collectionsBillboard
      })
    ),
    props.pathName === '/collections/rooms-for-guys' && React.createElement(DyPage, {
      addVariantToCart: props.addVariantToCart,
      checkout: props.checkout,
      dySlug: 'guys-lp-carousel',
      sliderId: 'guys-dy-slider'
    })
  );
};

CollectionsList.propTypes = {
  data: PropTypes.object.isRequired,
  pathName: PropTypes.string,
  addVariantToCart: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired,
  collectionsBillboard: PropTypes.object
};

export default CollectionsList;